import React from "react";
import * as ActivityOpts from "./activity_revision.json";
import * as ConclusionOpts from "./conclusion_revision.json";
import * as ExpensesOpts from "./expenses_revision.json";
import * as GoalOpts from "./goal_revision.json";
import * as InvetigationOpts from "./investigaton_revision.json";
import * as ParticipationOpts from "./participation_request_revision.json";
import * as ProfilesOpts from "./profiles_revision.json";
import * as ProjectOpts from "./project_revision.json";
import _ from 'lodash';

const RevisionComment = (props) => {
	let options = _.filter(_optsSwitch(props.opts),{'modality': props.modality});
	return (
		<select {...props} defaultValue="Ninguno">
			<option value="">--- Comentario ---</option>
			{options.map((item, key) => {
				return <option value={item.value} key={key}>{item.value}</option>
			})}
		</select>
	)
}

const _optsSwitch = (opts) => {
	switch (opts) {
		case 'activity':
			return ActivityOpts;
		case 'conclusion':
			return ConclusionOpts;
		case 'expenses':
			return ExpensesOpts;
		case 'goals':
			return GoalOpts;
		case 'investigation':
			return InvetigationOpts;
		case 'participation':
			return ParticipationOpts;
		case 'profiles':
			return ProfilesOpts;
		case 'project':
			return ProjectOpts;
		default:
			return []
	}
}

export default RevisionComment;


// WEBPACK FOOTER //
// ./src/elements/revision/widget/project_revision_select.jsx